import { Modal } from "@mantine/core";
import React from "react";
import { ReactComponent as CloseIcon } from "@assets/icons/close_bold.svg";

type ModalCalculatorHowWorksProps = {
  open: boolean;
  onClose(): void;
};

const ModalCalculatorHowWorks: React.FC<ModalCalculatorHowWorksProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      overlayProps={{
        opacity: 0.25,
      }}
      size={410}
      centered
      withCloseButton={false}
      opened={open}
      onClose={onClose}
      styles={{
        body: {
          padding: "0px",
        },
        content: {
          borderRadius: "16px",
          background: "#FFF",
          boxShadow:
            "0px 4px 6px -2px rgba(0, 0, 0, 0.06), 0px 12px 16px -4px rgba(0, 0, 0, 0.10)",
        },
      }}
    >
      <div className="flex items-center justify-between py-4 px-6">
        <span className="text-pn-headline-emphasis">How Calculator Works</span>

        <button onClick={onClose} className="btn-secondary-icon-xs">
          <CloseIcon />
        </button>
      </div>

      <div className="py-4 px-6">
        <p className="text-pn-caption-regular">
          This calculator is designed to give an indication of the monthly
          pension contribution you may need to mak in order to achieve your
          target monthly income in retirement. It is important to note that the
          calculator takes into account your target monthly income includes the
          Social Welfare pension, which Zurich Life assumes you will be entitled
          to when you retire. The calculations are in line with Zurich lIfe's
          Understating of Guidelines issues by the Society of Actuaries in
          Ireland (Actuarial Standard Practice Pen-12 . Version 1.7) and may
          change in the future. These figures are for illustrative purposes only
          and are not an offer of contract. These figures are estimates only.
          They are not a reliable guide to the future performance of your
          investment. Actual Investment growth will depend on the performance of
          the underlying investments and may be more or less than illustrated.
        </p>
      </div>
    </Modal>
  );
};
export default ModalCalculatorHowWorks;
